import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

import { countryTextByIdFilter } from "app/filters/ngFilters";

const formatCountryTextById = countryTextByIdFilter();

type Props = {
    countryCode: number;
};

const CountryText = ({ countryCode }: Props) => {
    return (
        <TruncatedTextWithTooltip
            data-automation="location-text"
            fontVariant="input2"
        >
            {formatCountryTextById(countryCode)}
        </TruncatedTextWithTooltip>
    );
};

export default CountryText;
